import FileLoaderService from './fileLoaderService';
import { DicomMetadataStore } from '@ohif/core';

let GblVar = window.GblVar;
let listNewImages = [];
window.memoImagens = [{ Serie: '', ImageId: '' }];

const addInstancesBySeries = async enabledVPElement => {
  if (enabledVPElement) {
    if (GblVar.InitLoadImages) {
      const imageIds = enabledVPElement.viewport.imageIds;
      const listImagesBySerie = window.memoImagens.filter(x => x.Serie === GblVar.SerieActive); //IMAGEM JÁ CARREGADA

      var serieAtual = GblVar.SeriesCarregadas.find(
        x => x.Serie === GblVar.SerieActive
      );
      if (listImagesBySerie.length > serieAtual.Number) {
        GblVar.SeriesCarregadas.filter(item => item.Serie === GblVar.SerieActive)[0].ImageIds = imageIds;
      } else {
        const imagensNaoCarregadas = listImagesBySerie.filter(obj => obj.ImageId && !imageIds.includes(obj.ImageId));
        await imagensNaoCarregadas.forEach(async obj => {
          const imageId = obj.ImageId;
          if (imageId) {
            const imageIdExist = imageIds.find(
              objImageId => objImageId === imageId
            );
            if (!imageIdExist) {
              imageIds.push(imageId);
              loadInCache(imageId, imageIds);
            }
          }
        });
      }
    }
  }
};

async function loadInCache(imageId, imageIds) {
  try {
    // var cache = cornerstone.cache.getImage(imageId);
    // if (cache) return;

    await cornerstone.imageLoader.loadImage(imageId);
    const options = getLoaderImageOptions(imageId, imageIds);
    await cornerstone.imageLoader.loadAndCacheImage(imageId, options);
  } catch (error) {
    console.error('Erro ao carregar cache da imagem:', error);
  }
}

// Mesmas options que OHIF usa ao carregar imagens ao percorrer pelo scroll
const getLoaderImageOptions = (imageId, imageIds) => {
      const imageIdIndex = imageIds.indexOf(imageId);

      const { transferSyntaxUID } = cornerstone.metaData.get('transferSyntax', imageId) || {};
      // const transferSyntaxUID  = window.services.displaySetService.activeDisplaySets?.find(x => x.SeriesInstanceUID === GblVar.SerieActive)
      //    .images?.find(x => x.imageId === imageId)?._meta?.TransferSyntaxUID?.Value[0] || {};

      const additionalDetails = { imageId, imageIdIndex };
      const options = {
          targetBuffer: {
              type: _shouldUseNativeDataType() ? undefined : 'Float32Array',
          },
          preScale: {
              enabled: true,
          },
          useRGBA: false,
          transferSyntaxUID,
          priority: 5,
          requestType: 'prefetch',
          additionalDetails,
      };
      return options;
};

const _shouldUseNativeDataType = () => {
    const { useNorm16Texture, preferSizeOverAccuracy } = cornerstone.getConfiguration().rendering;
    return useNorm16Texture || preferSizeOverAccuracy;
}

// const addInstancesBySeries = async (enabledVPElement) => {
//   if (enabledVPElement) {
//     if (GblVar.InitLoadImages) {
//       const imageIds = enabledVPElement.viewport.imageIds;
//       await listNewImages.forEach(imageId => {
//         if (imageIds) {
//           const imageIdExist = imageIds.includes(imageId);
//           if (imageIdExist === false)
//             imageIds.push(imageId);
//         }
//       });
//       GblVar.SeriesCarregadas.filter(item => item.Serie === GblVar.SerieActive)[0].ImageIds = imageIds;
//       //MEMO IMAGENS
//       //memoImagensCarregadas
//     }
//   }
// }

const addImageToList = imageId => {
  if (GblVar.SeriesCarregadas.length > 1);
  listNewImages.push(imageId);
};

const addSerieToList = serieNumber => {
  if (
    GblVar.ListSeries.some(item => item.Serie === GblVar.SerieActive) ===
      false &&
    GblVar.SeriesCarregadas.some(item => item.Serie === GblVar.SerieActive) ===
      false
  )
    GblVar.ListSeries.push({ Serie: GblVar.SerieActive, Number: serieNumber });
};

const allowedSRSOPs = [
  "1.2.840.10008.5.1.4.1.1.88.11", // Basic Text SR
  "1.2.840.10008.5.1.4.1.1.88.22", // Enhanced SR
  "1.2.840.10008.5.1.4.1.1.88.33", // Comprehensive SR
  "1.2.840.10008.5.1.4.1.1.88.40", // Procedure Log Storage
  "1.2.840.10008.5.1.4.1.1.88.50", // Mammography CAD SR
  "1.2.840.10008.5.1.4.1.1.88.59", // Key Object Selection Document
  "1.2.840.10008.5.1.4.1.1.88.65", // Chest CAD SR
  "1.2.840.10008.5.1.4.1.1.88.67" // X-Ray Radiation Dose SR
];

const processFile = async file => {
  try {
    GblVar = window.GblVar;
    const fileLoaderService = new FileLoaderService(file);
    const imageId = fileLoaderService.addFile(file);
    const image = await fileLoaderService.loadFile(file, imageId);
    const dicomJSONDataset = await fileLoaderService.getDataset(image, imageId);
    if (dicomJSONDataset.Modality === "SR" && allowedSRSOPs.includes(dicomJSONDataset.SOPClassUID)) {
      addFileSR(dicomJSONDataset);
      return;
    }
    GblVar.SerieActive = dicomJSONDataset.SeriesInstanceUID;
    addSerieToList(dicomJSONDataset.SeriesNumber);
    try {
      const imagemJaAdicionada = window.memoImagens.find(
        x =>
          x.Serie === dicomJSONDataset.SeriesInstanceUID &&
          x.SOPInstanceUID === dicomJSONDataset.SOPInstanceUID
      );
      if (imagemJaAdicionada === undefined) {
        window.memoImagens.push({
          Serie: dicomJSONDataset.SeriesInstanceUID,
          ImageId: imageId,
          SOPInstanceUID: dicomJSONDataset.SOPInstanceUID,
        });
        window.dispatchEvent(new Event('memoImagensUpdated'));
      }

      /*/
      let serieCarregada = window.memoImagens.filter(x => x.Serie === dicomJSONDataset.SeriesInstanceUID);
      if (serieCarregada.length === 0) {
        window.memoImagens.push({ Serie: dicomJSONDataset.SeriesInstanceUID, Imagens: [] });
        serieCarregada = window.memoImagens.filter(x => x.Serie === dicomJSONDataset.SeriesInstanceUID);
      }
      if (serieCarregada[0].Imagens.includes(imageId))
        serieCarregada[0].Imagens.push(imageId);
      /*/

      // const serieImageIds = window.GblVar.SeriesCarregadas.filter(x => x.Serie === dicomJSONDataset.SeriesInstanceUID)[0];
      // if (serieImageIds.ImageIds === undefined)
      //   serieImageIds.ImageIds = GblVar.InitLoadImages ? [] : { Serie: GblVar.SerieActive };
      // if (serieImageIds.ImageIds.includes(imageId) === false)
      //   serieImageIds.ImageIds.push(imageId);
    } catch (error) {
      console.log(error);
    }
    //addImageToList(imageId);
    //addInstanceBySeries(imageId);
    //window.filesDicomAdd.push(imageId);
    //if (window.filesDicomAdd.includes(imageId) === false)
    //cornerstone.imageLoader.loadImage(imageId);

    try {
      DicomMetadataStore.addInstance(dicomJSONDataset);
    } catch {}
    let activeSerie = window.services.DisplaySetService.activeDisplaySets.find(
      serie => serie.SeriesInstanceUID === dicomJSONDataset.SeriesInstanceUID
    );

    if (!activeSerie) {
      try {
        window.services.displaySetService.makeDisplaySets([dicomJSONDataset]);
        activeSerie = window.services.DisplaySetService.activeDisplaySets.find(
          serie =>
            serie.SeriesInstanceUID === dicomJSONDataset.SeriesInstanceUID
        );
      } catch (error) {}
    }

    if (
      activeSerie &&
      !activeSerie.images.some(
        image => image.SOPInstanceUID === dicomJSONDataset.SOPInstanceUID
      )
    ) {
      activeSerie.images.push(dicomJSONDataset);
    }
  } catch (error) {
    console.log(
      error.name,
      ':Error when trying to load and process local files:',
      error.message
    );
  }
};


export default async function filesToStudies(files, enabledVPElement) {
  listNewImages = [];
  const processFilesPromises = files.map(processFile);
  await Promise.all(processFilesPromises);
  await addInstancesBySeries(enabledVPElement);
  //if (GblVar.SeriesCarregadas.length === 1)
  //window.getImgsDCMBySerie();
  return DicomMetadataStore.getStudyInstanceUIDs();
}
